// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ar80","col":"styles_col__3ZZKJ","fulfillmentStatus":"styles_fulfillmentStatus__Reqj8","emailCol":"styles_emailCol__1_rRd"};